"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const vue_1 = __importDefault(require("vue"));
const index_vue_1 = __importDefault(require("./breadcrumb/index.vue"));
const index_vue_2 = __importDefault(require("./card/index.vue"));
const index_vue_3 = __importDefault(require("./data-table/index.vue"));
const index_vue_4 = __importDefault(require("./dict-option/index.vue"));
const components = {
    Breadcrumb: index_vue_1.default,
    Card: index_vue_2.default,
    DataTable: index_vue_3.default,
    DictOption: index_vue_4.default
};
Object.keys(components).forEach((key) => {
    vue_1.default.component(key, components[key]);
});
